import { Tabs as AntTabs, TabsProps } from 'antd';
// import { TabsProps } from 'antd';
// import { Tabs as RocketTabs } from 'rocket-ui';`
import styled from 'styled-components';

const StyledTabs = styled(AntTabs)`
  height: 100%;
  color: var(--gray-70);

  .ant-tabs-tab {
    padding: var(--tab-vertical-spacing) 0;
    margin: 0 var(--spacing-05) 0 0;
    border-bottom: 2px solid transparent;
  }

  .ant-tabs-tab:hover {
    color: var(--gray-70);
    border-bottom: 2px solid var(--gray-20);
  }

  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-tabpane {
    height: 100%;
  }

  .ant-tabs-content-holder {
    padding: 0 var(--spacing-06);
  }

  .ant-tabs-nav {
    padding: 0 var(--spacing-06);
    margin-bottom: 0;
  }

  .ant-tabs-nav::before {
    border-bottom: 1px solid var(--gray-10);
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--primary-color);
  }
`;

export { StyledTabs as Tabs };

export interface TabContainerProps extends TabsProps {
  className?: string;
}

export const TabContainer = ({ className, ...props }: TabContainerProps) => {
  return (
    <>
      <StyledTabs className={className} {...props} />
    </>
  );
};
